import { render, staticRenderFns } from "./ManagementInfo.vue?vue&type=template&id=596d5f29&scoped=true&"
import script from "./ManagementInfo.vue?vue&type=script&lang=js&"
export * from "./ManagementInfo.vue?vue&type=script&lang=js&"
import style0 from "./ManagementInfo.vue?vue&type=style&index=0&id=596d5f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596d5f29",
  null
  
)

export default component.exports